import axios from "axios"

export const paywallData = () => axios.get("/api/v2/paywall")

export const subscriptionChangeDetails = ({ currentPurchaseId, targetSubscriptionId }) =>
  axios.post(`/api/v2/web_subscription_purchases/${currentPurchaseId}/upcoming`, {
    new_web_subscription_id: targetSubscriptionId
  })

export const changePlan = ({ currentPurchaseId, targetSubscriptionId, prorationDate }) =>
  axios.post(`/api/v2/web_subscription_purchases/${currentPurchaseId}/change_subscription`, {
    proration_date: prorationDate,
    new_web_subscription_id: targetSubscriptionId
  })
